'use strict';

var legends = require('../config/legend-items.json');
var RomSummaryDateRangeChartLegendController = function RomSummaryDateRangeChartLegendController($scope) {
  $scope.aggregationModeList = [{
    label: 'Opportunity Trends',
    value: 'OPPORTUNITY_TREND'
  }, {
    label: 'Max, Actual, and Min Revenues',
    value: 'MIN_ACT_MAX_REVENUE'
  }, {
    label: 'Demand and Pax Actual vs. Optimal',
    value: 'DMND_PAX'
  }, {
    label: 'Avg Fare Actual vs. Optimal',
    value: 'AVG_FARE'
  }, {
    label: 'Demand Weighted Open % Actual vs. Optimal',
    value: 'DMND_WEIGHT'
  }];
  $scope.setDefaultState = function () {
    var defaultIndex = 0;
    $scope.aggregationMode = $scope.aggregationModeList[defaultIndex].value;
    $scope.dropdownModel = $scope.aggregationModeList[defaultIndex];
    $scope.legend = legends[$scope.aggregationMode];
  };
  $scope.onAggregationModeChange = function () {
    $scope.aggregationMode = $scope.dropdownModel.value;
    $scope.legend = legends[$scope.aggregationMode];
  };
  $scope.setDefaultState();
};
RomSummaryDateRangeChartLegendController.$inject = ['$scope'];
module.exports = RomSummaryDateRangeChartLegendController;